import { render } from "./gameLobby.vue?vue&type=template&id=06d45882&scoped=true"
import script from "./gameLobby.vue?vue&type=script&lang=js"
export * from "./gameLobby.vue?vue&type=script&lang=js"

import "./gameLobby.vue?vue&type=style&index=0&id=06d45882&scoped=true&lang=css"
import "./gameLobby.vue?vue&type=style&index=1&id=06d45882&lang=css"

import exportComponent from "/home/runner/work/user-ui/user-ui/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06d45882"]])

export default __exports__